import React from "react";
import { useState } from "react";

import { MasonryPhotoAlbum } from "react-photo-album";
import "react-photo-album/masonry.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";

import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";



import SideBar from "./components/SideBar";
import Container from "@mui/material/Container";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import photos from "./photos";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default function App() {
  const [index, setIndex] = useState(-1);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <SideBar />
      <Container>
        <MasonryPhotoAlbum photos={photos} onClick={({ index }) => setIndex(index)} />

        <Lightbox
          slides={photos}
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          // enable optional lightbox plugins
          plugins={[Fullscreen, Zoom, Captions, Thumbnails]}
          controller={{ closeOnBackdropClick: true, closeOnPullUp: true, closeOnPullDown: true }}
        />
      </Container>
    </ThemeProvider>
  );
}
